import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthenticationService} from "../services/authentication.service";
import {ProdDialogService} from 'prod-dialog';
import {ProdAppInjectorService} from 'prod-shared';
import {marker as _translate} from "@biesbjerg/ngx-translate-extract-marker"
import {DipExceptionService} from "../dip/dip-exception.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class HttpErrorHandlingInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService,
              private dialogService: ProdDialogService,
              private exceptionService: DipExceptionService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';

          if (request.url.split('/').pop() === ('login_check' || 'getMe')) {
            return throwError(this.translate(_translate('login.auth_error')));
          }

          if (error.status === 401) {
            this.authService.logout();
          }

          if (error.status === 403) {
            return this.dialogService.alert({
              message: this.translate(_translate('general.access_denied')),
              title: this.translate(_translate('general.error')),
            })
          }

          if (error.error.exception) {
            errorMsg = `Error: ${error.error.exception.message}`
            this.exceptionService.handleException(error.error.exception, request);
          } else if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
          } else {
            return this.dialogService.alert({message: error.message, title: `Error code: ${error.status}`});
          }
          return throwError(errorMsg);
        })
      )
  }

  translate(text) {
    const translate = ProdAppInjectorService.injector.get(TranslateService);
    return translate.instant(text);
  }
}
